import { FeatureFlagGuard } from '@platform/client/feature-flags';
import type { FeatureConfig } from '@platform/client/features';

import i18n from './locales/i18n';

export default {
  routes: [
    {
      path: 'saved-filters',
      element: <FeatureFlagGuard featureFlag="SAVED_ENTITY_FILTERS" />,
      children: [
        {
          lazy: () =>
            import('./pages/saved-filters-list/saved-filters-list.page'),
          index: true,
        },
      ],
    },
  ],
  navigation: ({ featureFlags }) => ({
    orgProfile: {
      savedFilters: featureFlags?.SAVED_ENTITY_FILTERS
        ? {
            title: i18n.t('savedFilters:title'),
            segment: '/saved-filters',
          }
        : null,
    },
  }),
} satisfies FeatureConfig;
